module.exports = __webpack_public_path__ + "img/splash-1.a932f918.png";